import { createReducer } from 'redux-starter-kit';
import { twoFactorActions } from '../actions';

const {
  set2FAStatus,
  set2FASetupData,
  clear2FASetupData,
  set2FABackupCodes,
  set2FALoading,
  set2FAError,
} = twoFactorActions;

export const twoFactorInitialState = {
  enabled: false,
  method: null,
  policy: 'optional', // 'disabled', 'optional', 'required' - controlled by admin
  canDisable: true, // Whether user can disable 2FA (false if policy is 'required')
  setupData: null, // Contains QR code, secret, backup codes during setup
  backupCodes: null, // Newly regenerated backup codes
  isLoading: false,
  error: null,
};

const set2FAStatusClbk = (state, action) => ({
  ...state,
  enabled: action.payload.enabled,
  method: action.payload.method,
  policy: action.payload.policy || 'optional',
  canDisable: action.payload.can_disable !== false, // Default to true if not provided
  error: null,
});

const set2FASetupDataClbk = (state, action) => ({
  ...state,
  setupData: action.payload,
  error: null,
});

const clear2FASetupDataClbk = (state) => ({
  ...state,
  setupData: null,
  backupCodes: null,
});

const set2FABackupCodesClbk = (state, action) => ({
  ...state,
  backupCodes: action.payload,
  error: null,
});

const set2FALoadingClbk = (state, action) => ({
  ...state,
  isLoading: action.payload,
});

const set2FAErrorClbk = (state, action) => ({
  ...state,
  error: action.payload,
});

const twoFactorReducer = createReducer(twoFactorInitialState, {
  [set2FAStatus]: set2FAStatusClbk,
  [set2FASetupData]: set2FASetupDataClbk,
  [clear2FASetupData]: clear2FASetupDataClbk,
  [set2FABackupCodes]: set2FABackupCodesClbk,
  [set2FALoading]: set2FALoadingClbk,
  [set2FAError]: set2FAErrorClbk,
});

export default twoFactorReducer;
